import React from "react";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Box, FormControlLabel, Switch, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MsgObjetoCreado from "../../componentes/MsgObjetoCreado";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "helpers/API";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg, getValorEditarODefault } from "helpers/helpers";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function ParametrosGeneralesForm({
    drawer,
    parametrosEdit,
    keyLista,
    setKeyLista,
    setRecargarTabla,
}) {
    const classes = useStyles();
    const [creado, setCreado] = useState(null);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);

    const tiposDeParametro = [
        { value: "integer", label: "Integer" },
        { value: "string", label: "String" },
        { value: "date", label: "Fecha" },
    ];
    const PARAMETROS = {
        INTEGER: tiposDeParametro[0],
        STRING: tiposDeParametro[1],
        DATE: tiposDeParametro[2],
    };

    const [selTipo, setSelTipo] = useState(PARAMETROS.INTEGER);
    const [parametroInicial, setParametroInicial] = useState(null);
    // Obligatorio al menos un valor - Lógica -
    const [showAlMenosUnValor, setShowAlMenosUnValor] = useState(false);
    const [id, setId] = useState(false);

    ///////

    useEffect(() => {
        if (parametrosEdit) {
            console.log("Ver parametrosEdit Aqui", parametrosEdit);
            const atributos = getAtributosBBDD(parametrosEdit);
            console.log("Ver los atributos", atributos);
            setParametroInicial(atributos);
            if (parametrosEdit.id) {
                setId(parametrosEdit.id);
            }
        }
    }, []);

    function parsearFechaFormik(fecha){
        if(!Boolean(fecha)){
            return ""
        }
        let  partes = fecha.split(" ")
        let fechaRaw = partes[0]
        partes = fechaRaw.split("/")
        const day = partes[0];
        const month = partes[1];
        const age = partes[2];
        return `${age}-${month}-${day}`; 
    }
    
    const parsearParametros = (nombre, param) =>
        param[nombre] === null ? "" : param[nombre];

    const isNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value);
    const getAtributosBBDD = (data) => {
        console.log("Ver valores reales", data)
        const param = { ...data };
        param.auxEntero1 = parsearParametros("auxEntero1", param);
        param.auxEntero2 = parsearParametros("auxEntero2", param);
        param.auxFecha1 = parsearParametros("auxFecha1", param);
        param.auxFecha2 = parsearParametros("auxFecha2", param);
        param.auxCadena1 = parsearParametros("auxCadena1", param);
        param.auxCadena2 = parsearParametros("auxCadena2", param);
        if (isNumber(param.auxEntero1) || isNumber(param.auxEntero2)) {
            param.tipo = PARAMETROS.INTEGER.value;
            setSelTipo(PARAMETROS.INTEGER);
        }
        if (param.auxCadena1 || param.auxCadena2) {
            param.tipo = PARAMETROS.STRING.value;
            setSelTipo(PARAMETROS.STRING);
        }
        if (param.auxFecha1 || param.auxFecha2) {
            param.tipo = PARAMETROS.DATE.value;
            setSelTipo(PARAMETROS.DATE);
            var f1 = parsearFechaFormik(param.auxFecha1);
            param.auxFecha1 = f1;
            var f2 = parsearFechaFormik(param.auxFecha2);
            param.auxFecha2 = f2;
        }
        return param;
    };

    const peticionBase = ({ url, dataRequest = {}, hook = false }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    function cargarParametro(datos) {
        var fecha1 = null;
        var fecha2 = null;
        var entero1 = null;
        var entero2 = null;
        var cadena1 = null;
        var cadena2 = null;
        switch (datos.tipoParametro) {
            case "date":
                fecha1 = parsearFechaParaBackend(datos.auxFecha1);
                fecha2 = parsearFechaParaBackend(datos.auxFecha2);
                break;
            case "string":
                cadena1 = datos.auxCadena1;
                cadena2 = datos.auxCadena2;
                break;
            case "integer":
                entero1 = datos.auxEntero1 === "" ? null : datos.auxEntero1;
                entero2 = datos.auxEntero2 === "" ? null : datos.auxEntero2;
                //entero2 = datos.auxEntero2 !== "" ? datos.auxEntero2 : null;
                break;
        }
        const handleRespuesta = () => {
            setCreado(true);
            setKeyLista(keyLista + 1);
            setRecargarTabla(true);
        };
        var parametro = {
            nombre: datos.nombre,
            nombreAbreviado: datos.nombreAbreviado,
            auxCadena1: cadena1,
            auxCadena2: cadena2,
            auxEntero1: entero1,
            auxEntero2: entero2,
            auxFecha1: fecha1,
            auxFecha2: fecha2,
            activado: datos.activado,
        };
        if (id) {
            parametro = {
                ...parametro,
                id: id,
            };
            let peticion = {
                url: "/generales/parametros/editar",
                hook: handleRespuesta,
                dataRequest: { ...parametro },
            };
            peticionBase(peticion);
        } else {
            let peticion = {
                url: "/generales/parametros/nuevo",
                hook: handleRespuesta,
                dataRequest: { ...parametro },
            };
            peticionBase(peticion);
        }
    }

    const validationSchema = Yup.object({
        nombre: Yup.string()
            .trim()
            .required("Campo requerido")
            .max(250, "Puede tener hasta ${max} caracteres"),
        nombreAbreviado: Yup.string()
            .trim()
            .required("Campo requerido")
            .max(250, "Puede tener hasta ${max} caracteres"),
        auxEntero1: Yup.number().when("tipoParametro", {
            is: "integer",
            then: Yup.number().integer("Ingrese un número entero"),
        }),
        auxEntero2: Yup.number().when("tipoParametro", {
            is: "integer",
            then: Yup.number().integer("Ingrese un número entero"),
        }),
        auxCadena1: Yup.string().when("tipoParametro", {
            is: "string",
            then: Yup.string()
                .trim()
                .max(250, "Puede tener hasta ${max} caracteres"),
        }),
        auxCadena2: Yup.string().when("tipoParametro", {
            is: "string",
            then: Yup.string().max(6000, "Puede tener hasta ${max} caracteres"),
        }),
        auxFecha1: Yup.date().when("tipoParametro", {
            is: "date",
            then: Yup.date(),
        }),
        auxFecha2: Yup.date().when("tipoParametro", {
            is: "date",
            then: Yup.date(),
        }),
    });

    const parsearFechaParaBackend = (fecha) => {
        if (!Boolean(fecha)) {
            return null;
        }
        const partes = fecha.split("-");
        const age = partes[0];
        const month = partes[1];
        const day = partes[2];
        return `${day}-${month}-${age}`;
    };
    /**
     *
     * @param {*} values
     * @returns {Boolean} Devuelve true si hay almenos un valor seteado
     */
    const hayAlmenosUnValorSeteado = (values) => {
        switch (values.tipoParametro) {
            case "date":
                return !(!values.auxFecha1 && !values.auxFecha2);
            case "string":
                return !(!values.auxCadena1 && !values.auxCadena2);
            case "integer":
                // Los caso entero cero son validos tambien
                if (values.auxEntero1 === 0 || values.auxEntero2 === 0) {
                    return true;
                }
                return !(!values.auxEntero1 && !values.auxEntero2);
        }
    };

    const formik = useFormik({
        initialValues: {
            nombre: getValorEditarODefault(parametroInicial, "nombre", ""),
            nombreAbreviado: getValorEditarODefault(
                parametroInicial,
                "nombreAbreviado",
                ""
            ),
            auxFecha1: getValorEditarODefault(
                parametroInicial,
                "auxFecha1",
                ""
            ),
            auxFecha2: getValorEditarODefault(
                parametroInicial,
                "auxFecha2",
                ""
            ),
            auxEntero1: getValorEditarODefault(
                parametroInicial,
                "auxEntero1",
                ""
            ),
            auxEntero2: getValorEditarODefault(
                parametroInicial,
                "auxEntero2",
                ""
            ),
            auxCadena1: getValorEditarODefault(
                parametroInicial,
                "auxCadena1",
                ""
            ),
            auxCadena2: getValorEditarODefault(
                parametroInicial,
                "auxCadena2",
                ""
            ),
            tipoParametro: parametroInicial
                ? parametroInicial.tipo
                : PARAMETROS.INTEGER.value,
            activado: getValorEditarODefault(
                parametroInicial,
                "activado",
                true
            ),
        },
        enableReinitialize: Boolean(parametrosEdit) ? true : false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            console.log("ver values", values);
            setShowAlMenosUnValor(false);
            if (hayAlmenosUnValorSeteado(values)) {
                cargarParametro(values);
                setSubmitting(false);
            } else {
                setShowAlMenosUnValor(true);
            }
        },
    });

    return (
        <div
            style={{
                margin: "20px",
                maxWidth: "30vw",
                width: "30vw",
            }}
        >
            {creado && (
                <MsgObjetoCreado
                    msg={
                        "El Parámetro ha sido " +
                        (parametrosEdit ? "actualizado" : "creado") +
                        " correctamente"
                    }
                    setCreado={setCreado}
                    drawer={drawer}
                />
            )}
            <form onSubmit={formik.handleSubmit}>
                <Box>
                    <Typography variant="h5">
                        {parametrosEdit != null ? "Actualizar " : "Nuevo "}
                        Parámetro General
                    </Typography>
                </Box>
                <APIMensajeMUI
                    mt={10}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <Box mt={1}>
                    <FormControlLabel
                        mt={10}
                        control={
                            <Switch
                                checked={formik.values.activado}
                                onChange={formik.handleChange}
                                id="activado"
                                name="activado"
                            />
                        }
                        label="Activa"
                    />
                </Box>
                <Box mt={1}>
                    <TextField
                        disabled={
                            Boolean(parametrosEdit)
                        }
                        variant="outlined"
                        className={classes.inputNuevaBanda}
                        label="Parámetro"
                        type="text"
                        id="nombreAbreviado"
                        name="nombreAbreviado"
                        value={formik.values.nombreAbreviado}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.nombreAbreviado &&
                            Boolean(formik.errors.nombreAbreviado)
                        }
                        helperText={
                            formik.touched.nombreAbreviado &&
                            formik.errors.nombreAbreviado
                        }
                    />
                </Box>
                <Box mt={1}>
                    <TextField
                        variant="outlined"
                        className={classes.inputNuevaBanda}
                        label="Descripción"
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formik.values.nombre}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.nombre &&
                            Boolean(formik.errors.nombre)
                        }
                        helperText={
                            formik.touched.nombre && formik.errors.nombre
                        }
                    />
                </Box>
                <Box mt={1}>
                    <SelectFieldMaterialUI
                        editar={Boolean(parametrosEdit)}
                        classNameFormControl={classes.inputNuevaBanda}
                        name="tipoParametro"
                        nombreLabel="Tipo de Parámetro"
                        formik={formik}
                        itemsArray={tiposDeParametro}
                        ejecutarAccion={(value) => {
                            setSelTipo({ value: value });
                        }}
                    />
                </Box>
                <Box mt={1}>
                    {selTipo && selTipo.value === "integer" && (
                        <>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Entero 1"
                                    type="number"
                                    id="auxEntero1"
                                    name="auxEntero1"
                                    value={formik.values.auxEntero1}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.auxEntero1 &&
                                        Boolean(formik.errors.auxEntero1)
                                    }
                                    helperText={
                                        formik.touched.auxEntero1 &&
                                        formik.errors.auxEntero1
                                    }
                                />
                            </Box>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Entero 2"
                                    type="number"
                                    id="auxEntero2"
                                    name="auxEntero2"
                                    value={formik.values.auxEntero2}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.auxEntero2 &&
                                        Boolean(formik.errors.auxEntero2)
                                    }
                                    helperText={
                                        formik.touched.auxEntero2 &&
                                        formik.errors.auxEntero2
                                    }
                                />
                            </Box>
                        </>
                    )}
                </Box>
                <Box mt={1}>
                    {selTipo && selTipo.value === "string" && (
                        <>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Cadena 1"
                                    type="text"
                                    id="auxCadena1"
                                    name="auxCadena1"
                                    value={formik.values.auxCadena1}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.auxCadena1 &&
                                        Boolean(formik.errors.auxCadena1)
                                    }
                                    helperText={
                                        formik.touched.auxCadena1 &&
                                        formik.errors.auxCadena1
                                    }
                                />
                            </Box>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Cadena 2"
                                    type="text"
                                    id="auxCadena2"
                                    name="auxCadena2"
                                    value={formik.values.auxCadena2}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.auxCadena2 &&
                                        Boolean(formik.errors.auxCadena2)
                                    }
                                    helperText={
                                        formik.touched.auxCadena2 &&
                                        formik.errors.auxCadena2
                                    }
                                />
                            </Box>
                        </>
                    )}
                </Box>
                <Box mt={1}>
                    {selTipo && selTipo.value === "date" && (
                        <>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Fecha 1"
                                    type="date"
                                    id="auxFecha1"
                                    name="auxFecha1"
                                    value={formik.values.auxFecha1}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.auxFecha1 &&
                                        Boolean(formik.errors.auxFecha1)
                                    }
                                    helperText={
                                        formik.touched.auxFecha1 &&
                                        formik.errors.auxFecha1
                                    }
                                />
                            </Box>
                            <Box mt={1}>
                                <TextField
                                    variant="outlined"
                                    className={classes.inputNuevaBanda}
                                    label="Fecha 2"
                                    type="date"
                                    id="auxFecha2"
                                    name="auxFecha2"
                                    value={formik.values.auxFecha2}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={
                                        formik.touched.auxFecha2 &&
                                        Boolean(formik.errors.auxFecha2)
                                    }
                                    helperText={
                                        formik.touched.auxFecha2 &&
                                        formik.errors.auxFecha2
                                    }
                                />
                            </Box>
                        </>
                    )}
                </Box>
                {showAlMenosUnValor && (
                    <Box>
                        <p style={{ color: "red" }}>
                            Debe completar, al menos, uno de los valores
                        </p>
                    </Box>
                )}
                <Box mt={3} style={{ float: "right" }}>
                    <Button type="submit" variant="contained" color="secondary">
                        {parametrosEdit ? "Actualizar" : "Crear"}
                    </Button>
                </Box>
            </form>
        </div>
    );
}
export default ParametrosGeneralesForm;
